<!--Element单选树形控件-->
<template>
	<div class="elUnitTreeBody">
		<el-scrollbar style="height:calc(100% - 10px);width: 100%;">
			<el-tree 
            :data="dataList" 
            :expand-on-click-node="false" 
            :current-node-key='defaultUnitId' 
            node-key="id" :props="defaultProps" 
            :highlight-current='true' 
            default-expand-all 
            :filter-node-method="filterNode" 
            ref="tree" 
            @node-click="nodeClick"
            >
				<span class="custom-tree-node" slot-scope="{node, data}">
			    <img src="../../../../public/static/image/elTree/1.9.png"/>
			 	<span style="padding-left: 5px;">{{data.name}}</span>
				</span>
			</el-tree>
		</el-scrollbar>
		
	</div>
</template>
<script>
import {areaFindArea} from '../../../api/energySubArea.js'

	export default {
		components: {},
		props: {
			filterText: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				defaultProps: {
					children: 'energyAreaVos',
					label: 'name'
				},
                dataList:[],
				defaultUnitId: '',
				seconds: 60,
				changeStatus: false,
				nowIndex: -1
			}
		},
		created() {},
		mounted() {
			
            //获取区域树
              areaFindArea({'unitId':this.unitId.id}).then(res => {
                    if(res.code == 200){
                        this.dataList = [res.data]
                        if(res.data.energyAreaVos.length != 0){
                             this.$store.cacheStore.commit("setBuilding", {
                            'name':res.data.energyAreaVos[0].name,
                            'id':res.data.energyAreaVos[0].id
                         })
                        }
                        
                    }
                })

		},
		destroyed() {},
		computed: {
            buildingNum(){
                // console.log("变化",this.$store.unitStore.state.buildingNum);
				return this.$store.unitStore.state.buildingNum
			},
			  unitId () {
					return this.$store.unitStore.state.nowUnit
				}
		},
		watch: {
            buildingNum:function(){
               this.energySubAreaFun()
			},
			filterText(val) {
				this.$refs.tree.filter(val);
			},
			
			unitId(val){
				this.energySubAreaFun()
			}
		},
		methods: {
            energySubAreaFun(){
                areaFindArea({'unitId':this.unitId.id}).then(res => {
                    // console.log("区域树",res);
                    if(res.code == 200){
                        this.dataList = [res.data]
						if(this.dataList[0].energyAreaVos.length == 0){
                          this.$store.cacheStore.commit("setBuilding", "")
						}else {
                          this.$nextTick(()=>{
							//默认选中
							this.$refs['tree'].setCurrentKey(this.dataList[0].energyAreaVos[0].id);
							this.$store.cacheStore.commit("setBuilding", this.dataList[0].energyAreaVos[0])
						  })
						}
						 
                    }
                })
            },
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				console.log("属性解封点击",value);
                this.$store.cacheStore.commit("setBuilding", value)
                // this.$store.cacheStore.commit("setBuilding", val)
				// value.name = value.label
				// this.$emit('checkItem', value)
				// this.$store.unitStore.commit("setNowUnit", value.id)
				// this.$store.unitStore.commit("setUnitGroupNo", value.id)
			},
		
			
		}
	}
</script>

<style>
  
	.elUnitTreeBody {
		height: 99.8%;
		background-color: white;
		width: 2.5rem;
		border: 1px solid #ded7d7;
		border-radius: 0 0 10px 10px
	}
	
	.elUnitTreeBody .el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden !important;
	}
	.el-scrollbar__wrap .el-scrollbar__view {
		width: 100%;
	}
	
	.el-tree {
		margin-top: 5px;
	}
	
	.el-tree-node :nth-child(2) {
		padding: 1px;
		overflow: visible;
	}
	
	.elUnitTreeBody .el-input-number--mini .el-input-number__decrease,
	.el-input-number--mini .el-input-number__increase {
		display: none;
	}
	
	.elUnitTreeBody .el-divider--horizontal {
		margin-top: 10px;
	}
</style>